export default "__VITE_ASSET__MtCEbUVX__"